export default __webpack_public_path__ + "static/media/pet-collage.d1b1855f.svg";